// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"switch__msignaturepad___2CHX6","m-signature-pad--body":"switch__m-signature-pad--body___37Ewv","m-signature-pad--footer":"switch__m-signature-pad--footer___1lNQs","description":"switch__description___1yqK2","button":"switch__button___2rkMG","clear":"switch__clear___2C3Jp","save":"switch__save___D5bLw","m-signature-pad":"switch__m-signature-pad___yTDbg","github":"switch__github___2fZsQ","on":"switch__on___5541T","thumb":"switch__thumb___2NBxv","ripple":"switch__ripple___1lzQf","off":"switch__off___zF2O7"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/switch.scss
// module id = +zLr
// module chunks = client